import { ChangeDetectionStrategy, Component, Input, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { ResponsiveImageElement } from 'app/model/interfaces';
import { BlockMargin } from '../../../service/article/article.service';
import { MarginService } from '../margin.service';

interface ImageBlockInterface
{
  image: ResponsiveImageElement;
  title?: string;
  subTitle?: string;
  linkDescription?: string;
  linkDestination?: string;
  left?: boolean;
}

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ImageComponent implements OnInit
{
  @Input() section: ImageBlockInterface;
  @Input() type: 'FullScreenImageSection' | 'ImageSection' | 'ImageWithBigCaptionSection' | 'ImageWithCaptionSection';
  @Input() margin: BlockMargin;

  constructor(public changeDet: ChangeDetectorRef, public marginService: MarginService) { }

  ngOnInit(): void
  {
  }

  @HostListener('window:resize', ['$event'])
  public onWindowResize($event): void
  {
    this.changeDet.detectChanges();

  }
}
